import React from 'react'

import influencerData from '../../data-influencer/total-body'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const TotalBody = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default TotalBody
